import React from 'react'
import { Link } from "react-router-dom";
import TenderNoticeBoard from "../components/common/TenderNoticeBoard";

export default function Navbar() {
  return (
    <div>
      <>
        <style>{`
  .tender-strip-wrap {
    padding: 0 14px 8px;
    background: linear-gradient(90deg, #f8fbff 0%, #eef5ff 100%);
    border-bottom: 1px solid #d7e7ff;
  }
  .tender-bar {
    background: #ffffff;
    border: 1px solid #dbe8ff;
    border-radius: 999px;
    box-shadow: 0 8px 24px rgba(13, 110, 253, 0.08);
    padding: 8px 10px 8px 14px;
    gap: 10px;
  }
  .tender-marquee-container {
    flex: 1;
    min-width: 0;
  }
  .view-all-btn {
    border-radius: 999px;
    padding: 0.42rem 0.95rem;
    font-weight: 600;
    border-color: #0d6efd;
    color: #0d6efd;
    white-space: nowrap;
  }
  .view-all-btn:hover {
    background: #0d6efd;
    color: #fff;
  }
  .marquee-outer {
    overflow: hidden;
    white-space: nowrap;
  }
  .marquee-inner {
    display: inline-flex;
    align-items: center;
    width: max-content;
    animation: tenderScroll 26s linear infinite;
    gap: 28px;
  }
  .marquee-track {
    display: inline-flex;
    align-items: center;
    gap: 28px;
  }
  .marquee-outer:hover .marquee-inner {
    animation-play-state: paused;
  }
  .tender-item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #0b1d45;
    font-size: 0.92rem;
    font-weight: 500;
    transition: color .2s ease;
  }
  .tender-item:hover {
    color: #0d6efd;
  }
  .new-badge {
    background: #dc3545;
    color: #fff;
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: .02em;
  }
  @keyframes tenderScroll {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }
  @media (max-width: 767.98px) {
    .tender-strip-wrap {
      padding: 0 8px 8px;
    }
    .tender-bar {
      border-radius: 14px;
      padding: 8px;
      gap: 8px;
    }
    .view-all-btn {
      padding: 0.35rem 0.7rem;
      font-size: 0.78rem;
    }
    .tender-item {
      font-size: 0.84rem;
    }
  }
`}</style>
        <style>{`
  .helpline-cta {
    border: 0;
    border-radius: 999px;
    padding: 0.48rem 1rem;
    font-weight: 800;
    color: #fff;
    text-decoration: none;
    background: linear-gradient(90deg, #ff6a00 0%, #ff1e1e 100%);
    box-shadow: 0 8px 18px rgba(255, 30, 30, 0.35);
    animation: helplineBlink 1s infinite;
    white-space: nowrap;
  }
  .helpline-cta:hover {
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 10px 20px rgba(255, 30, 30, 0.45);
  }
  .helpline-cta i {
    animation: helplineRing 0.8s infinite;
    transform-origin: 50% 0%;
  }
  @keyframes helplineBlink {
    0%, 100% { opacity: 1; filter: brightness(1); }
    50% { opacity: 0.65; filter: brightness(1.25); }
  }
  @keyframes helplineRing {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(10deg); }
    75% { transform: rotate(-10deg); }
  }
`}</style>
        {/* Topbar Start */}
        <div
          className="container-fluid px-0 tender-strip-wrap"
        >
          <div className="row gx-0 align-items-center  d-lg-flex">
            <div className="container-fluid">
              <div className="tender-bar d-flex align-items-center justify-content-between">

                {/* 🔁 Marquee Area */}
                <div className="tender-marquee-container">
                  <TenderNoticeBoard />
                </div>

                {/* ✅ Fixed View All Button */}
                <div className="view-all-wrapper">
                  <Link to="/tender" className="btn btn-sm btn-outline-primary view-all-btn">
                    View All
                  </Link>
                </div>

              </div>
            </div>

            {/* Left Side - Breadcrumbs */}
            {/* <div className="col-lg-6 px-5 text-start">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link className="small text-secondary" to="/">
              GOVERNMENT OF BIHAR
            </Link>
          </li>
          <li className="breadcrumb-item active small text-secondary" aria-current="page">
            SKIP TO MAIN CONTENT
          </li>
        </ol>
      </nav>
    </div> */}

            {/* Right Side - Social Icons */}
            {/* <div className="col-lg-6 px-5 text-end">
      <small className="me-2">Follow us:</small>
      <div className="d-inline-flex align-items-center">
        <Link className="btn btn-sm btn-square text-primary border-end rounded-0" to="/">
          <i className="fab fa-facebook-f" aria-hidden="true"></i>
        </Link>
        <Link className="btn btn-sm btn-square text-primary border-end rounded-0" to="/">
          <i className="fab fa-twitter" aria-hidden="true"></i>
        </Link>
        <Link className="btn btn-sm btn-square text-primary border-end rounded-0" to="/">
          <i className="fab fa-linkedin-in" aria-hidden="true"></i>
        </Link>
        <Link className="btn btn-sm btn-square text-primary pe-0" to="/">
          <i className="fab fa-instagram" aria-hidden="true"></i>
        </Link>
      </div>
    </div> */}

          </div>
        </div>


        {/* Topbar End */}
        {/* Brand & Contact Start */}
        <div className="container-fluid py-3 px-4 wow fadeIn" data-wow-delay="0.1s">
          <div className="row align-items-center top-bar">
            <div className="col-md-2" />
            <div className="col-md-8">
              <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center text-center">

                <Link to="/" className="navbar-brand m-0 p-0 mb-2 mb-lg-0 me-lg-3">
                  <img
                    src="/assests/img/baal-logo-footer.png"
                    alt="Logo"
                    style={{ width: 100, height: "auto" }}
                  />
                </Link>

                <div className="text-center mb-2 mb-lg-0 px-3">
                  <h1
                    className="mb-1"
                    style={{
                      fontFamily: '"Merriweather", serif',
                      fontWeight: 700,
                      fontSize: "2rem",
                      color: "#003366",
                      letterSpacing: 1
                    }}
                  >
                    बिहार बाल अधिकार संरक्षण आयोग
                  </h1>
                  <h2
                    className="mb-0"
                    style={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      color: "#0059b3",
                      letterSpacing: "0.5px"
                    }}
                  >
                    Bihar Commission for Protection of Child Rights
                  </h2>
                </div>

                <div className="d-flex align-items-center gap-2 ms-lg-3">
                  <Link to="#" className="navbar-brand m-0 p-0">
                    <img
                      src="/assests/img/bihargov.png"
                      alt="Logo"
                      style={{ width: 80, height: "auto" }}
                    />
                  </Link>
                  <Link to="#" className="navbar-brand m-0 p-0">
                    <img
                      src="/assests/img/swach-bharat.png"
                      alt="Logo"
                      style={{ width: 100, height: "auto" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-2" />
          </div>
        </div>
        {/* Brand & Contact End */}
        {/* Navbar Start */}
        <nav
          className="navbar navbar-expand-lg bg-primary navbar-dark sticky-top py-lg-0 px-lg-5 wow fadeIn"
          data-wow-delay="0.1s"
        >
          <Link to="#" className="navbar-brand ms-3 d-lg-none">
            MENU
          </Link>
          <button
            type="button"
            className="navbar-toggler me-3"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav me-auto p-3 p-lg-0">
              <Link to="/" className="nav-item nav-link active">
                Home
              </Link>

              <div class="nav-item dropdown">
                <Link to="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">About BSCPCR</Link>
                <div class="dropdown-menu border-0 rounded-0 rounded-bottom m-0">
                  <Link to="/AboutChildRights" class="dropdown-item">About Child Rights</Link>
                  <Link to="/about" class="dropdown-item">About Commission</Link>
                  <Link to="/Chairman" class="dropdown-item">Chairman</Link>
                  <Link to="/team" class="dropdown-item">Members</Link>
                  <Link to="/OrganizationStructure" class="dropdown-item">Organizational Structure</Link>

                  <Link to="/FunctionsAndPowers" class="dropdown-item">Functions and Powers</Link>

                  <Link to="/commissions" class="dropdown-item">Commissions formed till now</Link>

                </div>
              </div>

              <Link to="/acts" className="nav-item nav-link">
                Acts
              </Link>

              <Link to="/Sop" className="nav-item nav-link">
                SOP
              </Link>
              <div class="nav-item dropdown">
                <Link to="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Publications</Link>
                <div class="dropdown-menu border-0 rounded-0 rounded-bottom m-0">
                  <Link to="/AnnualReport" class="dropdown-item">Annual Report</Link>
                </div>
              </div>


              <div class="nav-item dropdown">
                <Link to="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Media</Link>
                <div class="dropdown-menu border-0 rounded-0 rounded-bottom m-0">
                  <Link to="/tender" className="dropdown-item">Notice Board/ Tender </Link>
                  {/* <Link to="#" class="dropdown-item">Press Release</Link>
                  <Link to="#" class="dropdown-item">BSCPCR in news</Link> */}
                  <Link to="/category" className="dropdown-item">Photo Gallery
                  </Link>
                  <Link to="/videos" className="dropdown-item"> Video Gallery </Link>
                </div>
              </div>

              <div class="nav-item dropdown">
                <Link to="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Acts & Rules</Link>
                <div class="dropdown-menu border-0 rounded-0 rounded-bottom m-0">
                <Link to="/BareActs" className="dropdown-item">
                  Bare acts related to children
                </Link>

                <Link to="/BSCPCRRules" className="dropdown-item">
                  BSCPCR Rules
                </Link>
              </div>
                </div>
              <Link to="/rti" className="nav-item nav-link">
                RTI
              </Link>
              <Link to="/RegisterComplaint" className="nav-item nav-link">
                Register Complaint
              </Link>
            </div>

            <div className="d-flex align-items-center px-3 pb-3 pb-lg-0">
              <a href="tel:1098" className="helpline-cta">
                <i className="fa fa-phone me-2"></i>
                Child Helpline: 1098 / 112
              </a>
            </div>

          </div>
        </nav>
        {/* Navbar End */}
      </>

    </div>
  )
}



